<template>
  <div>
    <b-navbar toggleable="md" type="dark">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="links">
          <b-nav-item to="/search">Produkty</b-nav-item>
          <template v-for="link in links">
            <b-nav-item :to="link.router">{{ link.text }}</b-nav-item>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

  <!-- <div class="sub-header row"> -->
    <!-- <div class="col-7"></div> -->
    <!-- <div class="col-12"> -->
      <!-- <div v-if="links" class="row"> -->
        <!-- <router-link class="top-links col-12 col-sm-6 col-lg-3" to="/search">Produkty</router-link> -->
        <!-- <span class="top-links col-12 col-sm-6 col-lg-3" v-for="link in links"> -->
          <!-- <router-link :to="link.router">{{link.text}}</router-link> -->
        <!-- </span> -->
      <!-- </div> -->
    <!-- </div> -->
  <!-- </div> -->

<script>
export default {
  data() {
    return {
      message: "",
      links: []
    };
  },
  beforeMount() {
    this.message = this.$config.get("header.top.message");
    this.links = this.$config.get("header.top.links");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/SubHeader.vue